import type { PopularSearch } from '@types'

import type { SWRResponse } from 'swr'

import useSWR from '@hooks/client/useSWR'
import { queryString } from '@lib/helpers/client'

// Get a list of popular searches.
// Limit must be a positive number includes between 1 and 10
export default function usePopularSearches(limit?: number): SWRResponse<PopularSearch[]> {
  const searchString = queryString({ results: limit || 4 })

  return useSWR<PopularSearch[]>(`/popular-searches?${searchString}`, undefined, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnMount: true,
    suspense: true,
    fallbackData: [],
  })
}
